<template>
  <div class="sidebar-hero-wrapper on-hover-x">
    <div class="sidebar-hero">
      <img class="x-btn" @click="closeSidebar" src="../assets/sidebar-x.svg" />
      <div class="media" v-if="checkMedia">
        <AFBImage
          v-if="getPointData.sidebar_hero.media.media_type === 'img'"
          :imageUrl="getPointData.sidebar_hero.media.image"
        />
        <AFBVideo
          v-else-if="getPointData"
          :source="getPointData.sidebar_hero.media.video_file.url"
        />
      </div>
      <div
        class="content"
        v-if="getPointData.sidebar_hero.content"
        v-html="getPointData.sidebar_hero.content"
      ></div>
    </div>
    <div class="click-outside" @click="closeSidebar"></div>
  </div>
</template>
<script>
import AFBImage from "@/components/AFBImage";
import AFBVideo from "@/components/AFBVideo";
export default {
  name: "Sidebar",
  components: { AFBVideo, AFBImage },
  methods: {
    closeSidebar() {
      this.$store.commit("setDrawer", false);
      this.$store.commit("setSidebar", false);
      this.$store.commit("setSelectedItem", null);
    },
  },
  computed: {
    checkMedia() {
      const { media } = this.getPointData.sidebar_hero;
      return media.image || media.video;
    },
    getPointData() {
      let selectedItem;
      if (this.$store.state.activeItemSidebar !== null) {
        selectedItem = this.$store.state.activeItemSidebar;
      } else {
        selectedItem = this.$router.currentRoute.params.id;
      }

      if (selectedItem !== null) {
        return this.$store.state.popups[selectedItem].acf;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/_typography";
@import "../assets/styles/_variables";
@import "../assets/styles/_colors";
@import "../assets/styles/_breakpoints";
.sidebar-hero-wrapper {
  height: calc(100vh - #{$headerHeight});
  width: 100%;
  position: fixed;
  right: 0;
  @include media("<=tablet") {
    z-index: 10000;
    width: 100%;
  }
}
.on-hover-x {
  &:hover {
    .x-btn {
      opacity: 1;
    }
  }
}
.x-btn {
  opacity: 0;
  transition: opacity 0.4s ease;
  cursor: pointer;
  height: 30px;
  color: white;
  left: 15px;
  top: 15px;
  position: absolute;
  z-index: 10000;
  @include media("<=tablet") {
    left: 0;
    opacity: 1;
  }
}
.sidebar-hero {
  z-index: 1;
  max-width: 507px;
  position: absolute;
  right: 0;
  background: url("~@/assets/paper-texture copy 6.png") round;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: calc(100vh - #{$headerHeight});
  @include media("<=tablet") {
    width: 100%;
    position: relative;
  }
  .media {
    width: 100%;
    max-height: 40%;
    min-height: 300px;
    overflow: hidden;
    img {
      min-font-size: 330px;
      width: 100%;
      height: 100%;
    }
  }
}
.content {
  padding: 52px 45px 50px 76px;
  text-align: left !important;
  display: flex;
  box-sizing: border-box;
  overflow: scroll;
  flex-direction: column;
  ::v-deep {
    p {
      margin-top: 21px;
    }
  }
  @include media("<=tablet") {
    ::v-deep {
      h1 {
        font-size: 40px;
        line-height: 44px;
      }
    }
    padding: 50px 30px;
    max-height: none;
  }
}
.click-outside {
  z-index: 0;
  width: 70%;
  height: 100%;
  position: absolute;
}
</style>
